"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.json.stringify.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _UploadImg = _interopRequireDefault(require("@/components/UploadImg"));

var _project = require("@/config/project");

var _rule = require("@/utils/rule");

var _vuex = require("vuex");

var _project2 = require("@/api/project");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ProjectInfo',
  components: {
    UploadImg: _UploadImg.default
  },
  data: function data() {
    return {
      id: '',
      cateMap: {},
      projectRule: _rule.projectRule,
      projectInfo: {
        'root_cate': 2,
        'second_cate': 3
      },
      targetInfo: {}
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['email'])),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var i;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (i = 0; i < _project.cateArr.length; i++) {
                _this.cateMap[_project.cateArr[i].id] = _project.cateArr[i]; // this.cateMap[cateArr[i].id].childMap = {}
                // for (let j = 0; j < cateArr[i].children.length; j++) {
                //   this.cateMap[cateArr[i].id].childMap[cateArr[i].children[j].id] = cateArr[i].children[j]
                // }
              }

              _this.id = _this.$route.params.id;

              _this.getProjectInfo();

              _this.getTargetInfo();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getProjectInfo: function getProjectInfo() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _project2.projectInfo)({
                  game_id: _this2.id
                });

              case 2:
                res = _context2.sent;
                _this2.projectInfo = res.data.data;
                _this2.projectInfo.notice_switch = res.data.data.notice_switch;
                _this2.projectInfo.root_cate = parseInt(res.data.data.root_cate);
                _this2.projectInfo.second_cate = parseInt(res.data.data.second_cate);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getTargetInfo: function getTargetInfo() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, targetInfo, tableMap, key;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _project2.projectTargetInfo)({
                  game_id: _this3.id
                });

              case 2:
                res = _context3.sent;
                targetInfo = res.data.data;
                tableMap = {};

                for (key in targetInfo) {
                  tableMap[key] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, targetInfo[key]), {}, {
                    data: [{
                      machine: '低档机',
                      data: targetInfo[key].low
                    }, {
                      machine: '中档机',
                      data: targetInfo[key].middle
                    }, {
                      machine: '高档机',
                      data: targetInfo[key].high
                    }]
                  });
                }

                _this3.targetInfo = tableMap;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    changeRootCate: function changeRootCate(rootCate) {
      this.projectInfo.second_cate = this.cateMap[rootCate].children[0].id;
    },
    updateProject: function updateProject() {
      var _this4 = this;

      this.$refs['updateForm'].validate(function (valid) {
        // debugger
        if (valid) {
          var _this4$projectInfo = _this4.projectInfo,
              game_id = _this4$projectInfo.game_id,
              game_name = _this4$projectInfo.game_name,
              game_desc = _this4$projectInfo.game_desc,
              root_cate = _this4$projectInfo.root_cate,
              game_img = _this4$projectInfo.game_img,
              second_cate = _this4$projectInfo.second_cate;
          var data = {
            game_id: game_id,
            game_name: game_name,
            game_desc: game_desc,
            root_cate: root_cate,
            game_img: game_img,
            second_cate: second_cate
          };
          (0, _project2.projectEdit)(data).then(function (res) {
            _this4.$message.success('修改成功');
          });
        }
      });
    },
    deleteProject: function deleteProject() {
      var _this5 = this;

      this.$confirm('确认删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'danger'
      }).then( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  (0, _project2.projectDel)({
                    game_id: _this5.projectInfo.game_id
                  }).then(function (res) {
                    _this5.$message.success('删除成功'); // 跳转到首页


                    _this5.$router.push({
                      name: 'Home'
                    });
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    changeNotify: function changeNotify() {
      var _this6 = this;

      // 如果通知打开，检查email，如果没有email，提示用户绑定邮箱
      if (this.projectInfo.notice_switch) {
        if (!this.email) {
          this.$message.warning('请先绑定邮箱');
          this.projectInfo.notice_switch = 0;
          return;
        }
      }

      (0, _project2.projectNotice)({
        game_id: this.id,
        notice_switch: this.projectInfo.notice_switch
      }).then(function (res) {
        _this6.$message.success('修改成功');
      });
    },
    saveTarget: function saveTarget() {
      var _this7 = this;

      var data = {};

      for (var key in this.targetInfo) {
        for (var i = 0; i < this.targetInfo[key].low.length; i++) {
          this.targetInfo[key].low[i] = Number(this.targetInfo[key].low[i]);
        }

        for (var _i = 0; _i < this.targetInfo[key].middle.length; _i++) {
          this.targetInfo[key].middle[_i] = Number(this.targetInfo[key].middle[_i]);
        }

        for (var _i2 = 0; _i2 < this.targetInfo[key].high.length; _i2++) {
          this.targetInfo[key].high[_i2] = Number(this.targetInfo[key].high[_i2]);
        }

        data[key] = {
          helpID: this.targetInfo[key].helpID,
          high: this.targetInfo[key].high,
          low: this.targetInfo[key].low,
          middle: this.targetInfo[key].middle,
          symbol: this.targetInfo[key].symbol,
          title: this.targetInfo[key].title,
          varName: this.targetInfo[key].varName
        };
      }

      console.log(this.targetInfo);
      (0, _project2.projectTargetEdit)({
        game_id: this.id,
        json: JSON.stringify(data)
      }).then(function (res) {
        _this7.$message.success('修改成功');
      }); // console.log(this.selectTargetType, this.list[this.selectTargetType])
    },
    goBack: function goBack() {
      this.$router.push({
        name: 'ProjectIndex',
        params: {
          id: this.id
        }
      });
    }
  }
};
exports.default = _default;